module.exports = __webpack_public_path__ + "img/13.f7d751b5.jpg";